export default "__VITE_ASSET__D_bB_9Ij__"